import { Master } from "../model/masters.model";

export const toFixed = (value: string | number | null | undefined, decimal: number = 2): string => (
    value ? (typeof value === 'string' ? parseFloat(value) : value).toFixed(decimal) : "0.00"
);

export const parseFixed = (value: string | number | null | undefined, decimal: number = 2): number => parseFloat(toFixed(value, decimal));

export const numberDisplay = (value: string | number | null | undefined, decimal: number = 2): string => {
    const v = parseFixed(value, decimal);
    if (v !== 0) {
        return v.toLocaleString('en-IN');
    }
    return "-";
};

export const toDrCr = (value: string | number | null | undefined, decimal: number = 2): string => {
    const v = parseFixed(value, decimal);
    return v === 0 ? 'NIL' : `${numberDisplay(Math.abs(v))} ${v < 0 ? 'CR' : 'DR'}`;
};

export const getDrCrColor = (value: string | number | null | undefined, decimal: number = 2): string => {
    const v = parseFixed(value, decimal);
    return v === 0 ? 'secondary' : v < 0 ? 'warning' : 'primary';
};

export const findInList = (list: Array<Master>, id?: string | number | null): string => {
    return id ? (list.find(l => l.id === id)?.name ?? '-') : '-';
};

export const removeLastFragment = (nameId: string, splitor?: string): string => {
    const names = nameId.split(splitor ?? '||');
    names.pop();
    return names.join(' ');
};

export const formatDate = (dateStr?: string | null): string => {
    if (!dateStr) {
        return '-';
    }
    const date = new Date(dateStr);
    return date.toLocaleDateString('de-DE'); // "dd.mm.yyyy"
};
